<template>
  <div >
    <div v-if="alumnos[0] && nivel == 2">
        <template v-if="observaciones[0].periodos.length">
            <div v-for="(periodo, p) in observaciones[0].periodos" :key="'p' + p">
                <vs-row  class="align-items-center">
                    <vs-col w="1">
                        <div style="height: 100%; -webkit-transform: rotate(-90deg); -moz-transform: rotate(-90deg);">
                            <p class="text-center fontNine">{{periodo.periodo}}</p>
                        </div>
                    </vs-col>
                    <vs-col w="11">
                        <div class="obsCampoFormativo" >
                            <div>
                                <div v-for="(camp, p) in periodo.campos_formativos" :key="'p' + p">
                                    <div :class="periodo.campos_formativos.length == (p + 1) ? '' : 'divisorObs'">
                                        <p class="text-center mb-0 fontTen lineTogether"><strong>{{camp.campo_formativo}}</strong></p>
                                        <template v-if="camp.observaciones_ids[0]">
                                            <p v-for="(obs, o) in camp.observaciones_ids" :key="'o' + o" class="mb-0 fontTen lineTogether"><i class="fas fa-caret-right mr-1"></i>{{obs}}</p>
                                        </template>
                                        <p class="fontTen lineTogether" v-else>No hay observaciones</p>
                                    </div>
                                    <div :class="periodo.campos_formativos.length == (p + 1 ) ? '' : 'lineSeparadorCampoFormativo'"></div>
                                </div>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <div class="lineSeparadorCampoFormativo"></div>
            </div>
        </template>
        <template v-else>
            <div class="mt-4 text-center">
                <h4>No se cuenta con observaciones.</h4>
            </div>
        </template>
    </div>
    <modal-actualizar-calificacion v-model="activeCalificacion" :informacion="informacionCalificacion" @refreshTable="getRefreshTable"></modal-actualizar-calificacion>
  </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import ModalActualizarCalificacion from './modal/actualizar-calificacion.vue'
export default {
    props: ['nivel','alumnos', 'persona', 'permisos', 'forceRefresh', 'observaciones'],
    data:() => ({
        tipo: 1,
        numCabecera: '',
        tipo_formato: '',
        verInfo: [],
        mostrar: false,
        force: 0,
        activeCalificacion: false,
        informacionCalificacion: {}
    }),
    components:{
        ModalActualizarCalificacion
    },
  methods: {
    getRefreshTable(){
        this.$emit("refreshTable")
    },
    getNumTotalCabecera(){
        const cabecera = this.alumnos[0].header_periodos
        const rol = 'administrador'
        const vm = this
        if(rol == 'administrador'){
            vm.numCabecera = cabecera.length
        }
    },
    getCalificacionById(periodos, cabecera){
        //Colocar el promedio en el periodo correspondiente de campos formativos
        let calif = ''
        periodos.forEach(p => {
            if(p.detalle_componente_id == cabecera.detalle_componente_id){
                calif = p.calificacion
                return false
            }
        })
        return calif
    },
    getPromediosById(periodos, promedio){
        //Colocar el promedio en el periodo correspondiente
        let calif = ''
        periodos.forEach(p => {
            if(p.detalle_componente_id == promedio.detalle_componente_id){
                calif = p.calificacion
                return false
            }
        })
        return calif
    },
    getPeriodosShow(info){
        const arreglo = []
        const infor = this.alumnos[0].header_periodos
        infor.forEach(element => {
            let array = {}
            if(element.status_show_alumno == true){
                array = {
                    detalle: element.detalle_componente_id,
                    status: true
                }
            }else{
                array = {
                    nombre: false,
                    status: false
                }
            }
            arreglo.push(array)
        })
        this.verInfo = arreglo
    },
    generarPDF() {
        const loading = this.$vs.loading({
            text: 'Descargando PDF, esto puede demorar un poco.'
        })
        var intro = document.getElementById('generalBoletas')
        intro.style.display = 'block'
        // Seleccionar el contenido que deseas convertir a PDF
        const pages = document.querySelectorAll('.alumno')
            const pdf = new jsPDF({
            orientation: 'portrait', // o 'landscape'
            unit: 'mm',
            format: 'letter',
            compress: true,
            fontSize: 12,
            lineHeight: 1.2,
            setMargins: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        });
        
        pages.forEach((page, index) => {
            // Utilizar html2canvas para capturar el contenido como una imagen
            html2canvas(page, {
                scale: 1, // Ajusta la escala para mejorar la calidad
                quality: 0.9, // Ajusta la calidad de la imagen
            }).then(canvas => {

                // Convertir la imagen en base64 y agregarla al PDF
                const imageData = canvas.toDataURL('image/png');
                pdf.addImage(imageData, 'PNG', 3, 3, 210, 273);

                // Agregar una nueva página si no es la última
                if (index < pages.length - 1) {
                    pdf.addPage();
                } else {
                    // Guardar el PDF cuando se procesan todas las páginas
                    pdf.save('Boleta');
                    intro.style.display = 'none';
                    this.$emit('loadingBoton');
                    loading.close()
                }
            })
        })
    
    },
    
    async getCalificaciones (tipo) {
        if(this.alumnos[0]){
            this.tipo_formato = 'admin'
            const loading = this.$vs.loading({
                text: 'Por favor, espere. Esto puede tardar un poco.',
            })
            try {
                // const params = {
                    // ciclo_escolar_id:  this.filtros.cicloEscolar,
                    // institucion_id: this.filtros.institucion,
                    // programa_id: this.filtros.programa
                // }
                // let datos = [663]
                // for(var x = 0;x < this.selected.length; x++){
                //     datos.push(this.selected[x].persona_id)
                // }
                
                // params.persona_alumno_id = datos
                // params.accion = 'descarga'
                // const { data: response } = await reportes.getDescargarBoletas(params)
                
                this.getNumTotalCabecera()
                this.getPeriodosShow()
                // setTimeout(()=>{
                //     this.generarPDF()
                // }, 500)
                    loading.close()
            } catch (error) {
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: 'Hubo un error, favor de contactar al administrador.'
                })
                    
            }
        }
    },
    getModificar(infoG, calif, calificacion, tipo, index_materia, index_calificacion, tipoCalificacion){
        const persona = JSON.parse(this.persona)
        if(persona.roles[0].name != 'Usuario Principal'){
            this.activeCalificacion =! this.activeCalificacion
            this.informacionCalificacion ={
                "infoCalif": calif,
                "calificacionActual": calificacion,
                "infoCalifGen": infoG,
                "tipoModificar": tipo,
                "index_materia": index_materia,
                "index_calificacion": index_calificacion,
                "tipoCalificacion": tipoCalificacion
            }
        }
    },
  },
  watch: {
    alumnos(){
        this.getCalificaciones()
    }
  }
}
</script>

<style scoped>
.fontTen{
    font-size: 12px;
}
.fontSix{
    font-size: 13px;
}
.fontEight{
    font-size: 15px;
}
.fontNine{
    font-size: 16px;
}

.cabeceraTable{
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
}

p{
    margin-bottom: 0;
}

.lineTogether {
    line-height: 1.5;
}

table tr th{
    font-size: 7px;
    margin: 0 2px;
}

.widthCabecera2{
    width: 50%;
}
.widthCabecera3{
    width: 33.3%;
}
.widthCabecera4{
    width: 25%;
}
.widthCabecera5{
    width: 20%;
}
.widthCabecera6{
    width: 16.6%;
}
.widthCabecera7{
    width: 14.28%;
}
.widthCabecera8{
    width: 12.5%;
}
.widthCabecera9{
    width: 11.11%;
}
.widthCabecera10{
    width: 10%;
}
.widthCabecera11{
    width: 9%;
}
.widthCabecera12{
    width: 8.33%;
}
.widthCabecera13{
    width: 7.69%;
}
.widthCabecera14{
    width: 7.14%;
}
.widthCabecera15{
    width: 6.66%;
}
.widthCabecera16{
    width: 6.25%;
}

.lineSeparadorCampoFormativo{
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0;
}
.lineSeparador{
    width: 99.5%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0 2px 0.5%;
}
.backgroundCampos:nth-last-child(even){
    background: rgba(217, 217, 217, 0.30);
}
.bottom-div {
    position: absolute;
    bottom: 0;
    width: 1240px;
    text-align: center;
}
</style>

<style lang="scss">
// Small tablets and large smartphones (landscape view)
$screen-xsm-min: 200px;
// Small tablets and large smartphones (landscape view)
$screen-sm-min: 576px;

// Small tablets (portrait view)
$screen-md-min: 768px;

// Tablets and small desktops
$screen-lg-min: 992px;

// Large tablets and desktops
$screen-xl-min: 1200px;
//Extra Small devices
@mixin xsm {
   @media (min-width: #{$screen-xsm-min}) {
       @content;
   }
}
// Small devices
@mixin sm {
   @media (min-width: #{$screen-sm-min}) {
       @content;
   }
}

// Medium devices
@mixin md {
   @media (min-width: #{$screen-md-min}) {
       @content;
   }
}

// Large devices
@mixin lg {
   @media (min-width: #{$screen-lg-min}) {
       @content;
   }
}

// Extra large devices
@mixin xl {
   @media (min-width: #{$screen-xl-min}) {
       @content;
   }
}

.widthBoletaStyle{
    @include xsm {
        width: 1080px;
    }
    @include xl {
        width: 100%;
    }
}
</style>
